import { render, staticRenderFns } from "./EmployeePayRollForSignWidget.vue?vue&type=template&id=ee357d9c&scoped=true&"
import script from "./EmployeePayRollForSignWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeePayRollForSignWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee357d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee357d9c')) {
      api.createRecord('ee357d9c', component.options)
    } else {
      api.reload('ee357d9c', component.options)
    }
    module.hot.accept("./EmployeePayRollForSignWidget.vue?vue&type=template&id=ee357d9c&scoped=true&", function () {
      api.rerender('ee357d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/widgets/EmployeePayRollForSignWidget.vue"
export default component.exports